import api from '@api';
import { withArchive } from 'src/resources/withArchive';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getReturnsGridFetchSuccess, getReturnsGridFetchFailure } from './reducer';
import { ReturnsGridResType } from 'src/types/returnsGrid';
import { GridRequestType } from 'src/types/table';
import { RootStoreType } from 'src/types/store';

export const RETURN_GRID_URL = 'api/secure/returns/grid';
export const RETURN_GRID_ALL_PROVIDERS_URL = 'api/secure/returns/grid-all-providers';
export const RETURN_GRID_PRODUCTS_URL = 'api/secure/returns/returnsProducts';

export interface GetReturnGridCallPayloadType {
    params: GridRequestType;
    allProviders: boolean;
    archive?: boolean;
}

const getReturnsGridFetchRequest = async (payload: GetReturnGridCallPayloadType) => {
    const res = await api(
        'post',
        withArchive(payload.allProviders ? RETURN_GRID_ALL_PROVIDERS_URL : RETURN_GRID_URL, payload.archive),
        payload.params
    );
    return res.data.data;
};

function* getReturnsGridFetch(action: { type: string; payload?: GetReturnGridCallPayloadType }) {
    try {
        let payloadData: GetReturnGridCallPayloadType | undefined = action.payload;
        if (!payloadData) {
            const params: GridRequestType = yield select((state: RootStoreType) => state.returnsGrid.data?.request);
            const allProviders: boolean = yield select((state: RootStoreType) => state.returnsGrid.allProviders);
            const archive: boolean = yield select((state: RootStoreType) => !!state.returnsGrid.archive);
            if (params) {
                payloadData = {
                    params,
                    allProviders,
                    archive,
                };
            }
        }
        if (payloadData) {
            // @ts-ignore
            const response: ReturnsGridResType = yield call((): any => getReturnsGridFetchRequest(payloadData));
            yield put(getReturnsGridFetchSuccess(response));
        } else {
            yield put(getReturnsGridFetchFailure({ error: null }));
        }
    } catch (error) {
        yield put(getReturnsGridFetchFailure({ error }));
    }
}

export function* getReturnsGridFetchWatch() {
    yield takeEvery('returnsGrid/getReturnsGridFetch', getReturnsGridFetch);
}
